import { BrandForCreate, BrandsParams } from "@/store/dictionaries/brands";
import { formatDateToYYYYMMDD } from "../utils/DateParser";

export function areBrandFieldsValid(brand: BrandForCreate): boolean {
    return !(!brand.brand.brand_name || !brand.brand.brand_pk || !brand.brand_patterns.every(str => str.pattern.length > 0) || brand.categories.length == 0)
}

export function setBrandsParamsByFilter(params: BrandsParams, settings: TableSettings) {
    if (settings.orderField) {
        params.order_by = settings.orderField;
    } else {
        params.order_by = '-mtime';
    }

    if (settings.commonFilter) {
        params.brand_name__ilike = settings.commonFilter;
    }

    if (Object.keys(settings.filter).length > 0) {
        if (settings.filter.name) {
            params.brand_name__ilike = settings.filter.name;
        }

        if (settings.filter.pattern) {
            params.patterns__pattern__ilike = settings.filter.pattern;
        }

        if (settings.filter.user.length > 0) {
            params.cuser__id__in = settings.filter.user.join(",");
        }

        if (settings.filter.category.length > 0) {
            params.categories__category_id__in = settings.filter.category.join(",");
        }

        if (settings.filter.cdate)
            params.cdate = formatDateToYYYYMMDD(settings.filter.cdate);

        if (settings.filter.mdate)
            params.mdate = formatDateToYYYYMMDD(settings.filter.mdate);

        if (settings.filter.use_in_wb_parser.length > 0) {
            params.is_used_in_wbparser = settings.filter.use_in_wb_parser == "1" ? true : false;
        }

        if (settings.filter.use_in_dl.length > 0) {
            params.is_used_in_datalens = settings.filter.use_in_dl == "1" ? true : false;
        }
    }
}

export const createBrandPk = (str: string): string =>
    str.replace(/[^a-zA-Zа-яА-ЯёЁ0-9]+/g, '_').toLowerCase();


interface TableSettings {
    first: number;
    orderField: string;
    commonFilter: string;
    filter: FilterForm;
}

export interface FilterForm {
    name: string;
    pattern: string;
    cdate: Date | null;
    mdate: Date | null;
    user: number[];
    category: number[],
    use_in_wb_parser: string;
    use_in_dl: string;
}